module.exports = __webpack_public_path__ + "static/media/home_page_survivor_background@768.72d61900.png";